import apiClient from './api-client'

export interface Notification {
  id: string
  type: string
  icon: string
  message: string
  count: number | null
  route: string
  priority: 'high' | 'medium' | 'low'
  timestamp: string
}

export interface NotificationSummary {
  pending_leave: number
  pending_overtime: number
  pending_ob: number
  pending_offset: number
  total: number
}

const notificationService = {
  async getNotifications(): Promise<{ status: boolean; data: Notification[]; total: number }> {
    const response = await apiClient.get('/notifications')
    return response.data
  },

  async getSummary(): Promise<{ status: boolean; data: NotificationSummary }> {
    const response = await apiClient.get('/notifications/summary')
    return response.data
  },
}

export default notificationService
